import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify, {
    lang: {
      locales: { pt },
      current: 'pt',
    },
  })

export default new Vuetify({
  theme: {
    themes: {
        light: {
            primary: '#16A34A',
            secondary: '#F1F5F9',
            tertiary: '#F1F5F9',
        },
    },
},
});
